import { httpClient } from '@/utils/httpClient';
import { API_CONFIG } from '@/config/api';
import type { SystemConfigRow } from '@/types/systemConfig';

const ENDPOINT = API_CONFIG.ENDPOINTS.ADMIN_CONFIG;

export const configAdminService = {
  async list(prefix?: string): Promise<SystemConfigRow[]> {
    const params = prefix ? `?prefix=${encodeURIComponent(prefix)}` : '';
    return httpClient.get<SystemConfigRow[]>(`${ENDPOINT}${params}`);
  },

  async update(configKey: string, configValue: unknown): Promise<SystemConfigRow> {
    return httpClient.patch<SystemConfigRow>(`${ENDPOINT}/${encodeURIComponent(configKey)}`, {
      config_value: configValue,
    });
  },
};
